// components/Mobile/Components/Social.js

import React from 'react';
import styles from './Social.module.css';

// Replace with your actual image paths
import asset1 from '../../../assets/social-asset-8m.png';
import asset2 from '../../../assets/social-asset-5m.png';
import asset3 from '../../../assets/social-asset-6m.png';
import asset4 from '../../../assets/social-card3.png';
import asset5 from '../../../assets/safe3-asset2.png';
import asset6 from '../../../assets/social-asset-7m.png';

const Social = () => {
  return (
    <section className={styles.social}>
       <div className={styles.textContainer}>
          <h1 className={styles.title}>SOCIAL</h1>
        </div>
      <div className={styles.assetContainer}> 
        <img src={asset1} alt="Asset 1" className={styles.asset1} />
        <img src={asset2} alt="Asset 2" className={styles.asset2} />
        <img src={asset3} alt="Asset 3" className={styles.asset3} />
        <img src={asset4} alt="Asset 4" className={styles.asset4} />
        <img src={asset5} alt="Asset 5" className={styles.asset5} />
        <img src={asset6} alt="Asset 6" className={styles.asset6} />
      </div>
       <div className={styles.textContainer}>
       
        <p className={styles.paragraph}>No swiping through people</p>
      </div> {/* End of leftColumn */}
    </section>
  );
};

export default Social;
